module.exports = Promise.resolve("6b029632af46b8ac");